import React from "react";

const Button = ({
  children,
  fullWidth = false,
  disabled = false,
  className = "",
  onClick,
  type = "button",
  ...props
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`px-6 py-2 h-[42px] bg-slate-700 text-white text-sm font-semibold rounded-xl hover:bg-slate-800 transition-colors duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed ${className} ${fullWidth ? "w-full" : ""}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
